import { connect } from 'react-redux'
import AllMoshaveranUI from './AllMoshaveranUI'
import { Dispatch } from 'redux';
import ApplicationState from '../../../../../../../ApplicationState';
import AllMoshaveranState from '../../State/AllMoshaveranState';
import IState from '../../../../../../Util/IState';
import IDispatcher from '../../../../../../Util/IDispatcher';
import { AllMoshaveranDispatch } from './model';
import { actionFetchAllMoshaveran } from '../../Actions/ActionCreator';
import { ActionType } from '../../Actions/ActionTypes';



const mapStateToProps = (state: ApplicationState): IState<AllMoshaveranState> => {
    return {
        state: state.allMoshaveran
    }
}

const mapDispatchToProps = (dispatch: Dispatch): IDispatcher<AllMoshaveranDispatch> => ({
    dispatcher: {
        fetchAllMoshaveranList: () => { dispatch(actionFetchAllMoshaveran() as any) },
        show: () => { dispatch({ type: ActionType.ALL_MOSHAVERAN_SHOW }) }
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(AllMoshaveranUI)